import * as React from 'react'

import { css, Global, useTheme } from '@emotion/react'

import { Colors } from '../theme/colors'

interface Props {
  bodyBackground?: Colors
}

interface GlobalStyleTextOptions {
  bodyBackground: string
  bodyColor: string
  bodyTypography: string
  colorScheme: 'dark' | 'light'
  mediumWeight: number
}

export const getCashWebGlobalStyleText = ({
  bodyBackground,
  bodyColor,
  bodyTypography,
  colorScheme,
  mediumWeight,
}: GlobalStyleTextOptions) => `
        * {
          font-family: 'Cash Sans', 'Helvetica Neue', helvetica, sans-serif;
        }

        html {
          box-sizing: border-box;
        }

        *,
        *::before,
        *::after {
          box-sizing: inherit;
        }

        body {
          background: ${bodyBackground};
          color: ${bodyColor};
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;

          ${bodyTypography}
          /* Resetting line-height to browser default to overwrite the line-height set in theme.typography.body
          * This is to ensure that the line-height is not inherited by non-text elements.
          */
          line-height: unset; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */

          /* Sets system UI like scrollbars and unstyled inputs to match the theme's color scheme. */
          color-scheme: ${colorScheme};
        }

        body,
        div,
        dl,
        dt,
        dd,
        ul,
        ol,
        li,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        pre,
        form,
        fieldset,
        input,
        textarea,
        p,
        blockquote,
        th,
        td,
        hr {
          margin: 0;
          padding: 0;
        }

        table {
          border-collapse: collapse;
          border-spacing: 0;
        }

        fieldset,
        img {
          border: 0;
        }

        address,
        caption,
        cite,
        code,
        dfn,
        em,
        th,
        var {
          font-style: normal;
          font-weight: normal; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
        }

        strong,
        b {
          font-style: normal;
          font-weight: ${mediumWeight}; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
        }

        ol,
        ul {
          list-style: none;
        }

        caption,
        th {
          text-align: left;
        }
      `

const GlobalStyles: React.FC<Props> = ({ bodyBackground = 'background' }) => {
  const theme = useTheme()
  return (
    <Global
      styles={css`
        ${getCashWebGlobalStyleText({
          bodyBackground: theme.colors[bodyBackground],
          bodyColor: theme.colors.body,
          bodyTypography: theme.typography.body,
          colorScheme: theme.darkMode ? 'dark' : 'light',
          mediumWeight: theme.weights.medium,
        })}
      `}
    />
  )
}

export default GlobalStyles
